import React from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';

const Finances: React.FC = () => {
  const transactions = [
    { id: '1', date: '2026-03-01', desc: 'Levy Payment - Unit 1', type: 'income', amount: 850 },
    { id: '2', date: '2026-03-05', desc: 'Gardening Service', type: 'expense', amount: 320 },
    { id: '3', date: '2026-03-10', desc: 'Levy Payment - Unit 2', type: 'income', amount: 850 },
    { id: '4', date: '2026-03-12', desc: 'Electricity - Common', type: 'expense', amount: 180 }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Financial Overview</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead><TableRow><TableCell>Date</TableCell><TableCell>Description</TableCell><TableCell>Type</TableCell><TableCell align="right">Amount</TableCell></TableRow></TableHead>
          <TableBody>
            {transactions.map(t => (
              <TableRow key={t.id}><TableCell>{t.date}</TableCell><TableCell>{t.desc}</TableCell><TableCell><Chip label={t.type} color={t.type === 'income' ? 'success' : 'error'} size="small" /></TableCell><TableCell align="right">${t.amount.toFixed(2)}</TableCell></TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default Finances;
